export default "__VITE_ASSET__Vkss30EL__"